/**
 *  Filename ....: event-messages.component.ts
 *  Created by ..: ianday
 *  on Date .....: 2/28/24
 **/
import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {UserService} from "../../../../../services/user.service";
import {MessageDefinitionService} from "../../../../../services/messages.service";
import {MatLegacyTableDataSource as MatTableDataSource} from "@angular/material/legacy-table";
import {ServiceRequestType} from "../../../../../models/service-request-type";
import {MatSort} from "@angular/material/sort";
import {Settings} from "../../../../../services/settings";
import {DataRecord} from "../../../../requests/commands/req-status/req-status.component";

class AppEventMessages {
    id: number;
    eventDescription: string;
    messageId: number;
    messageDescription: string;

    constructor(id:number, evdesc:string, messageId:number, msgDesc:string) {
        this.id = id;
        this.eventDescription = evdesc;
        this.messageId = messageId;
        this.messageDescription = msgDesc;
    }
}
@Component({
    selector: 'event-messages',
    templateUrl: './event-messages.component.html',
    styleUrls: ['./event-messages.component.css']
})

export class EventMessagesComponent implements OnInit {

    public enabledList:any;
    public selectedValue: string;
    public settingsRecord: any;
    public currentRunState: string;
    public editMode: boolean = false;

    public displayedColumns: string[] = ['id', 'eventDescription', 'messageId', 'messageDescription',];
    public dataSource: MatTableDataSource<any>;
    public Idx = -1;

    public messageDefs: any
    public appEvents: any;
    public selectedRecord: any;
    public records: any;

    public fetchedMessageDefs = false;
    public fetchedAppEvents = false;
    public messageDropDownItems: any
    public visibleModify: boolean = false;

    constructor(public settingsService: UserService, public messagesService:MessageDefinitionService) {
        this.enabledList = [];
        this.enabledList.push({id: 'true', description: 'Enabled'});
        this.enabledList.push({id: 'false', description: 'Disabled'});

    }

    @ViewChild(MatSort, { static: true }) sort: MatSort;

    ngOnInit() {
        if(Settings.getInstance().hasPrivilege('GENERAL_SETTINGS_UNASSIGNED_REQUEST_EMAILS', "WRITE")) {
           this.visibleModify = true;
        }
        /** start the daisy chain **/
        this.queryMessageDefs();
    }
    public queryMessageDefs(): void {

        if(!this.fetchedMessageDefs) {
            this.fetchedMessageDefs = true;
            this.messagesService.getAllActiveMessageDefinitions().subscribe(
                (results) => {
                    this.messageDropDownItems = [];
                    this.messageDropDownItems.push(new DataRecord(0, '- No Message -'));
                    this.messageDefs = results;

                    for(let rec of this.messageDefs) {
                        this.messageDropDownItems.push(new DataRecord(rec.id, rec.description));
                    }

                    this.queryApplicationEvents();
                },
                (error) => {
                    Settings.getInstance().handleError(error, 'Fetching active message definitions');
                });
        }
        else {
            this.queryApplicationEvents();
        }
    }
    public queryApplicationEvents() {

        if(!this.fetchedAppEvents) {
            this.messagesService.getAllActiveApplicationEvents().subscribe(
                (results) => {
                    this.appEvents = results;
                    this.queryMessageEvents();
                },
                (error) => {
                    Settings.getInstance().handleError(error, 'Fetching application events');
                });
        }
        else {
            this.queryMessageEvents();
        }
    }
    public queryMessageEvents() {
        this.records = [];
        this.messagesService.getAllMessageEvents().subscribe(
            (results) => {
                for(let rec of this.appEvents) {
                    const msgEv = results.find(s => s.applicationEventId === rec.id)
                    let appEvId = rec.id;
                    let messageId = 0;
                    let messageDesc = '';

                    if(msgEv !== undefined) {
                        messageId = msgEv.messageId;
                        appEvId = msgEv.applicationEventId;
                        let md = this.messageDropDownItems.find(s => s.id === messageId);

                        if(md !== undefined) {
                            messageDesc = md.description;
                        }
                    }
                    else {
                        messageId = 0;
                        messageDesc = this.messageDropDownItems.find(s => s.id === messageId).description;
                    }
                    this.records.push(new AppEventMessages( appEvId, rec.description, messageId, messageDesc ));
                }
                this.dataSource = new MatTableDataSource(this.records);
            },
            (error) => {
                Settings.getInstance().handleError(error, 'Fetching message events');
            }
        )

    }
    public tableKeyDown(event: KeyboardEvent) {
        if (this.editMode) {
            return;
        }

        const len: number = this.dataSource.filteredData.length;
        if (event.key === 'ArrowDown') {
            if (this.Idx < (len - 1)) {
                this.selectedRecord = this.dataSource.filteredData[++this.Idx];
                this.selectRow();
            }
        } else if (event.key === 'ArrowUp') {
            if (this.Idx > 0) {
                this.selectedRecord = this.dataSource.filteredData[--this.Idx];
                this.selectRow();

            }
        }
    }
    public selectRow() {
        if (this.selectedRecord.id === 0) {
            this.unSelectRow();
            return;
        }
        this.Idx = this.dataSource.filteredData.findIndex(s => s.id === this.selectedRecord.id);
    }
    public unSelectRow() {
        this.Idx = -1;
        this.selectedRecord = new ServiceRequestType();
    }
    @HostListener('matSortChange', ['$event'])
    onSortChange(event: any) {

        if (this.editMode) {
            event.preventDefault();
            return;
        }

        if (event.direction === 'asc') {
            if (event.active === 'id') {
                this.records.sort((a, b) =>
                    a[event.active] - (b[event.active]));
            }
            else {
                this.records.sort((a, b) =>
                    a[event.active].localeCompare(b[event.active]));
            }
        } else {
            if (event.active === 'id') {
                this.records.sort((a, b) =>
                    b[event.active] - (a[event.active]));
            }
            else {
                this.records.sort((a, b) =>
                    b[event.active].localeCompare(a[event.active]));
            }
        }

        this.dataSource.data = this.records;

        this.selectRow();

    }
    public onRowClicked(selected: any) {

        if (this.editMode) {
            return;
        }

        this.selectedRecord = selected;
        this.selectRow();
    }
    public onMessageChange(record: any): void {

        this.records[this.Idx].messageDescription
            = this.messageDropDownItems.find(s => s.id === record.messageId).description;

           this.messagesService.updateMessageEvent(record.id, record.messageId).subscribe(
            (result) => {
                /* do nothing */
            },
            (error) => {
                Settings.getInstance().handleError(error, 'Updating message events');
            }
        )
    }
    public returnMessageColor(id:number): string {

        if(id > 0) {
            return 'green';
        }

        return 'gray';
    }
}


